import { render } from "./PanelProductPricing.vue?vue&type=template&id=6b677c3b"
import script from "./PanelProductPricing.vue?vue&type=script&lang=js"
export * from "./PanelProductPricing.vue?vue&type=script&lang=js"

import "./PanelProductPricing.vue?vue&type=style&index=0&id=6b677c3b&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__